import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
const truncate = css `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const Container = styled.div `
  display: flex;
  flex-direction: column;

  max-width: inherit; // Firefox fix, otherwise the text is not ellipsed

  gap: ${({ $dense }) => ($dense ? pxToRem(2) : '0')} 0;

  text-decoration: none;

  .tct-text {
    font-family: ${themeGet('fontFamily.default')};
    font-weight: ${themeGet('fontWeight.regular')}
    font-style: ${themeGet('fontStyle.normal')};
    line-height: ${themeGet('lineHeight.neutralized')};
    ${truncate}
  }

  .tct-primary {
    font-size: ${themeGet('fontSize.small')};
    color: ${themeGet('colors.text.300')};
  }

  .tct-secondary {
    font-size: ${themeGet('fontSize.tiny')};
    color: ${themeGet('colors.text.100')};
  }
`;
